/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientDocument } from './PatientDocument';
import {
    PatientDocumentFromJSON,
    PatientDocumentFromJSONTyped,
    PatientDocumentToJSON,
    PatientDocumentToJSONTyped,
} from './PatientDocument';

/**
 * 
 * @export
 * @interface PatientDocumentsResponsePaginated
 */
export interface PatientDocumentsResponsePaginated {
    /**
     * 
     * @type {Array<PatientDocument>}
     * @memberof PatientDocumentsResponsePaginated
     */
    documents?: Array<PatientDocument>;
    /**
     * 
     * @type {number}
     * @memberof PatientDocumentsResponsePaginated
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientDocumentsResponsePaginated
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientDocumentsResponsePaginated
     */
    totalElements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatientDocumentsResponsePaginated
     */
    last?: boolean;
}

/**
 * Check if a given object implements the PatientDocumentsResponsePaginated interface.
 */
export function instanceOfPatientDocumentsResponsePaginated(value: object): value is PatientDocumentsResponsePaginated {
    return true;
}

export function PatientDocumentsResponsePaginatedFromJSON(json: any): PatientDocumentsResponsePaginated {
    return PatientDocumentsResponsePaginatedFromJSONTyped(json, false);
}

export function PatientDocumentsResponsePaginatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientDocumentsResponsePaginated {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(PatientDocumentFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'size': json['size'] == null ? undefined : json['size'],
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'last': json['last'] == null ? undefined : json['last'],
    };
}

export function PatientDocumentsResponsePaginatedToJSON(json: any): PatientDocumentsResponsePaginated {
    return PatientDocumentsResponsePaginatedToJSONTyped(json, false);
}

export function PatientDocumentsResponsePaginatedToJSONTyped(value?: PatientDocumentsResponsePaginated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(PatientDocumentToJSON)),
        'page': value['page'],
        'size': value['size'],
        'totalElements': value['totalElements'],
        'last': value['last'],
    };
}

